module.exports = __webpack_public_path__ + "img/p2-31.500325aa.png";